import moment from "moment";

export const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});

export const getConfigByPromo = (promoList = []) => {
  const safePromoList = Array.isArray(promoList) ? promoList : [];

  const baseColumn = {
    name: "namaCabang",
    label: "Cabang",
    options: {
      sort: false,
    },
  };

  const promoColumns = safePromoList.map((promo) => ({
    name: promo,
    label: promo,
    options: {
      sort: false,
    },
  }));

  return [baseColumn, ...promoColumns];
};

export const buildExcelRequestBodyPenjualanByPromo = ({
  month,
  year,
  dataTable = [],
  rawData = [],
}) => {
  const yearValue = year?.value || year;
  const monthValue = month?.label || month;

  const filename = `${yearValue}_${monthValue}_Laporan_Penjualan_By_Promo`;
  const promoNames = [
    ...new Set(
      rawData.flatMap((item) =>
        (item.dataPromo || []).map((promo) => promo.namaPromo),
      ),
    ),
  ];

  const sheets = [];

  if (dataTable.length > 0 && promoNames.length > 0) {
    sheets.push({
      name: `Laporan Penjualan By Promo ${monthValue} ${yearValue}`,
      headers: [
        "No",
        "Cabang",
        ...promoNames, 
      ],
      data: dataTable.map((rowData, rowIndex) => {
        const row = {
          No: rowIndex + 1,
          Cabang: rowData.namaCabang,
        };

        promoNames.forEach((promoName) => {
          row[promoName] = rowData[promoName] ?? 0;
        });

        return row;
      }),
    });
  }

  return {
    filename,
    sheets,
  };
};